import gql from "graphql-tag";
import { pageContent } from '~/graphql/queries/pageContent'

export const pageQuery = gql`
  query Page($publicationState: PublicationState!, $slug: String!) {
    pages(filters:{slug: {eq: $slug}}, publicationState: $publicationState) {
      ${pageContent}
    }
  }
`